import { useCallback, useEffect } from "react";
import { RecruiterActivity } from "redux/models/recruiterActivity";
import { useAPIRequest } from "hooks/useAPIRequest";
import { Modal } from "common/components/modal/modal";
import { Flex } from "common/components/flex/flex";
import { Skeleton } from "common/components/skeleton/skeleton";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import { CandidateLinkItem } from "../../../../components/candidateLinkItem/candidateLinkItem";
import { toShortUSFormat } from "utilities/dateUtility";
import { SectionError } from "../../../../components/sectionError";

export const TotalHiresModal = ({ open, onClose, clientId, recruiterId }) => {
  const fetchHires = useCallback(
    () => RecruiterActivity.monthlyHires(clientId, recruiterId, false),
    [clientId, recruiterId],
  );

  const { data, loading, error, execute } = useAPIRequest(fetchHires, {
    initialData: [],
    initialLoading: true,
  });

  const title = loading ? "Total Hires" : `Total Hires (${data?.length ?? 0})`;

  const renderContent = () => {
    if (loading) {
      return <Skeleton paragraph={{ rows: 11, width: "100%" }} />;
    }

    if (error) {
      return (
        <SectionError title="Failed to load data" message={error.message} />
      );
    }

    if (data.length === 0) {
      return (
        <Flex align="start" justify="center" style={{ flexGrow: 1 }}>
          <EmptyPlaceholder description="No hires for the current month" />
        </Flex>
      );
    }

    return (
      <Flex direction="column" gap={8} style={{ width: "100%" }}>
        {data.map(({ id, startDate, candidate, job }) => {
          return (
            <CandidateLinkItem
              key={candidate.id}
              candidateId={candidate.id}
              jobEntryId={id}
              name={`${candidate.fullName} (${job.title})`}
            >
              <span className="text-secondary">{candidate.email}</span>
              <span>Start Date: {toShortUSFormat(startDate)}</span>
            </CandidateLinkItem>
          );
        })}
      </Flex>
    );
  };

  useEffect(() => {
    if (clientId && recruiterId) {
      execute();
    }
  }, [clientId, recruiterId, execute]);

  return (
    <Modal open={open} onCancel={onClose} title={title} footer={null}>
      <div style={{ minHeight: "300px" }}>{renderContent()}</div>
    </Modal>
  );
};
